import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import cjDetail from '../views/cjDetail.vue'
import blank from '../views/blank.vue'
import index from '../views/index.vue'
import cjScore from '../views/cjScore.vue'
import cjCarType from '../views/cjCarType.vue'
import detail from '../views/detail.vue'
import oauth from '../views/oauth.vue'
import login from '../views/login.vue'
import download from '../views/download.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/cjDetail',
    name: 'cjDetail',
    component: cjDetail,
    meta: {
      keepAlive: false,
      isBack: false
    }
  },
  {
    path: '/cjCarType',
    name: 'cjCarType',
    component: cjCarType,
    meta: {
      keepAlive: true,
      isBack: false,
      isLogin: false,
      title: '拆解列表'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: download,
    meta: {
      keepAlive: false,
      isBack: false,
      title: '下载手机App'
    }
  },
  {
    path: '/cjScore',
    name: 'cjScore',
    component: cjScore,
    meta: {
      keepAlive: false,
      isBack: false,
      title: '拆解项评分'
    }
  },
  {
    path: '/:time/:entityId',
    name: 'detail',
    component: detail,
    meta: {
      keepAlive: false,
      isBack: false
    }
  },
  {
    path: '/detail',
    name: 'newDetail',
    component: detail,
    meta: {
      keepAlive: false,
      isBack: false
    }
  },
  {
    path: '/blank',
    name: 'blank',
    component: blank
  },
  {
    path: '/oauth',//微信授权
    name: 'oauth',
    component: oauth
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      keepAlive: false,
      isBack: true,
      isLogin: true,
      title: '登录'
    }
  },
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '拆车坊-首页',
      keepAlive: true,
      isBack: false,
    }
  },
  {
    path: "*",
    redirect: { name: 'index' }
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
